import { render } from "./TheMyCollectionMain.vue?vue&type=template&id=35a40a86&scoped=true&ts=true"
import script from "./TheMyCollectionMain.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionMain.vue?vue&type=script&lang=ts"

import "./TheMyCollectionMain.vue?vue&type=style&index=0&id=35a40a86&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a40a86"]])

export default __exports__